import { queryKeyPrefix } from 'src/features/tanStackQuery/queryKeyPrefix'

const prefix = queryKeyPrefix.labelMaster

export const labelMasterQueryKeys = {
  labelMasters: {
    all: [...prefix, 'labelMasters'] as const,
    list: (params: { keywords: string[]; limit: number; offset: number }) =>
      [...prefix, 'labelMasters', 'list', params] as const,
    detail: (id: string) => [...prefix, 'labelMasters', 'detail', id] as const,
  },
  labels: {
    all: [...prefix, 'labels'] as const,
    byLabelMaster: (labelMasterId: string) =>
      [...prefix, 'labels', 'byLabelMaster', labelMasterId] as const,
    detail: (id: string) => [...prefix, 'labels', 'detail', id] as const,
  },
  labelNames: {
    all: [...prefix, 'labelNames'] as const,
  },
  labelAreaNames: {
    all: [...prefix, 'labelAreaNames'] as const,
  },
}
